import { on } from "infrastructure/eventHub";
import { useEffect, useState } from "react";

export function useChatSelected({ id, repository } = {}) {
  const [element, setElement] = useState(null);

  const refresh = async (id) => {
    let element = null;
    if (id) {
      element = await repository.getById(id);
    }
    setElement(element);
  }

  useEffect(() => {
    refresh(id);

    const unsub = on("repository", repository.storeName, "updated", async () => {
      refresh(id);
    });

    return unsub;
  }, [id]);

  return element;
}